import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Settings from "./pages/Settings";
import AdminUsers from "./pages/AdminUsers";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      {/* 1. ROUTER MUST BE THE TOP-LEVEL WRAPPER */}
      <BrowserRouter>
        {/* 2. AUTH PROVIDER INSIDE ROUTER */}
        <AuthProvider>
          
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected Routes Wrapper */}
            {/* This renders the Sidebar (Layout) for all child paths */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              {/* Redirect root "/" to "/dashboard" */}
              <Route index element={<Navigate to="/dashboard" replace />} />
              
              {/* Pages */}
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              
              {/* Role-Protected Admin Pages */}
              <Route path="settings" element={
                <ProtectedRoute requiredRole="admin">
                  <Settings />
                </ProtectedRoute>
              } />
              
              <Route path="admin-users" element={
                <ProtectedRoute requiredRole="admin">
                  <AdminUsers />
                </ProtectedRoute>
              } />

            </Route>
            
            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;